import styled, { css, IFalconTheme, Scale, StyledComponent } from '@se-admin/falcon';

const BOOKING_TAB_MINIMUM_HEIGHT: number = 238;

export const BookingsPageWrapper: StyledComponent<'div', IFalconTheme> = styled('div')(
  ({ theme }: { theme: IFalconTheme }) => css`
    background-color: ${theme.color.white};
  `
);

export const BookingPageTabContainer: StyledComponent<'div', IFalconTheme> = styled('div')`
  min-height: ${BOOKING_TAB_MINIMUM_HEIGHT}px;
`;

export const BookingsPageHeader: StyledComponent<'div', IFalconTheme> = styled('div')(
  ({ theme }: { theme: IFalconTheme }) => css`
    background-color: ${theme.color.white};
    padding: ${Scale.m};
  `
);
